module.exports = __webpack_public_path__ + "img/4-1.29f01987.svg";